import { useTranslation } from 'react-i18next';

import * as S from './PDFDownload.styles';
import { Options } from './components/Options';

export function PDFDownload(): React.ReactElement {
  const { t } = useTranslation();

  return (
    <S.Wrapper>
      <S.Title
        color="grayDarkSecondary"
        textAlign="center"
        fontWeight="extraLight"
        tag="h2"
        scale="xl"
        fontFamily="LFT Zeno"
      >
        {t('pdf.customizePdf')}
      </S.Title>

      <Options />
    </S.Wrapper>
  );
}
